module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_3009.20a7aecf.png";